import { ReactElement, useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { CommunityContext } from '../../../common_lib_front/communityConfigs/communityContextProvider';
import ScormWrapper from '../../../common_lib_front/components/scormWrapper/scormWrapper';
import { SpecialInstruction } from '../../../common_lib_front/components/SpecialInstruction';
import { Auto2fa } from '../../../components/2faModal/auto2fa';
import style from './guestCommunityRule.module.css';

type locationStateType = {
  overwriteAllowSkip?: boolean;
}

export default function GuestCommunityRule(): ReactElement {
  const history = useHistory();
  const { propertySlug, registrationId } = useParams<{ propertySlug: string, registrationId: string }>();
  const { state } = useLocation<locationStateType | undefined>();
  const [showButton, setShowButton] = useState(true);
  const { featuresConfig } = useContext(CommunityContext);

  console.log(state);

  const submitHandler = () => {
    // const nextPageURL = `/guest/${propertySlug}/${registrationId}/payment-request`;
    history.push(`/guest/${propertySlug}/${registrationId}/payment-request`);
  };

  useEffect(() => {
    setShowButton(
      state?.overwriteAllowSkip ?? featuresConfig?.guest?.educationStepSkippable ?? true,
    );
    // if (featuresConfig?.guest?.educationStepSkippable === false) {
    //   setShowButton(false);
    // }
  }, [featuresConfig, state?.overwriteAllowSkip]);

  return (
    <div className={style.container}>
      <div className={`${style.box} white `}>
        <div className={`${style.passForm} `}>
          <div className={style.headerwraper}>
            <h1 className={`${style.subHeaderTitle} textColorBlack`} >
              Review the community guidelines.
            </h1>
            <SpecialInstruction
              pathName="guest.v2.community-rules"
              sx={{
                mt: 1,
              }}
            />
            <div className={style.subHeaderNote}>Please watch the video in order to procceed.</div>
          </div>
          <div className={style.videoBox}>
            <div className={style.videoContainer}>
              <ScormWrapper continueHandler={() => submitHandler()} portal="guest" />
            </div>
          </div>
          <div className={`${style.innerBox} ${style.buttonBox}`}>
            <div className={style.buttonContainer}>
              {(
                showButton ? <button onClick={submitHandler} className={style.button} type="submit">
                  I agree to community guidelines
                </button> : null
              )}
            </div>
          </div>
        </div>
      </div>
      <Auto2fa />
    </div>
  );
}
